import React from "react";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-links">
        {/* Follow Us */}
        <div className="footer-column">
          <h4 className="footer-title">Follow Us</h4>
          <ul className="footer-list">
            <li>
              <a href="#">Google Scholar ↗</a>
            </li>
            <li>
              <a href="#">ResearchGate ↗</a>
            </li>
            <li>
              <a href="#">Facebook ↗</a>
            </li>
            <li>
              <a href="#">Instagram ↗</a>
            </li>
          </ul>
        </div>

        {/* Working Hours */}
        <div className="footer-column">
          <h4 className="footer-title">Working Hours</h4>
          <ul className="footer-list">
            <li>Mon – Sat: 9:00 AM – 6:00 PM</li>
            <li>Sunday: 9:00 AM – 1:00 PM</li>
            <li>
              <FaEnvelope className="footer-icon" />{" "}
              <a href="mailto:editor@ijsrem.com">sratheeshtpm@gmail.com</a>
            </li>
            <li>
              <FaPhoneAlt className="footer-icon" />{" "}
              <a href="tel:+919391167991">+91-9095059984</a>
            </li>
          </ul>
        </div>

        {/* Contact Us */}
        <div className="footer-column">
          <h4 className="footer-title">Contact Us</h4>
          <p className="footer-text">
            <strong>
              International Journal of Advanced Communication and Network
              Applications (IJACNA)
            </strong>
            <br />
            {/* <br />
            SEASENSE RESEARCH (OPC) PRIVATE LIMITED */}
            <br />
            {/* <FaMapMarkerAlt className="footer-icon" /> #62/1, New No 7, 1st Cross, 2nd Main, Ganganagar, R T Nagar, Bangalore North,<br />
            Bangalore, Karnataka, India – 560032 */}
          </p>
          <a href="/ContactUs" className="footer-link-highlight">
            Visit Contact Page ↗
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} IJACNA — All Rights Reserved.</p>
      </div>
    </footer>
  );
}
